import { render, staticRenderFns } from "./addUserInfoTwo.vue?vue&type=template&id=96416378&scoped=true"
import script from "./addUserInfoTwo.vue?vue&type=script&lang=js"
export * from "./addUserInfoTwo.vue?vue&type=script&lang=js"
import style0 from "./addUserInfoTwo.vue?vue&type=style&index=0&id=96416378&prod&lang=scss&scoped=true"
import style1 from "./addUserInfoTwo.vue?vue&type=style&index=1&id=96416378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96416378",
  null
  
)

export default component.exports